const timer = {"time": 0}
import Yaafloop from "yaafloop"
Yaafloop(function(delta) {
    timer.time += delta.s
})

export default timer
